import React from 'react';
import { AppBar, Stack, Typography, Button, Box } from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import { useTheme } from '@mui/system';

function PackReviewHeader({ title, backText, onClickBack, showCards = false, showModal = null, numCards = null }) {
    const theme = useTheme();

    return (
        <AppBar position='sticky' sx={{ color: 'black', backgroundColor: '#FFFFFF' }}>
            <Stack p={2} spacing={1}>
                <Stack>
                    <Button
                        variant='text'
                        startIcon={<ArrowBackIos />} 
                        onClick={onClickBack}
                        style={{ color: theme.palette.text.secondary, paddingTop: '0px', paddingBottom: '0px', width: 'fit-content', fontSize: '14px'}}
                    >
                        <Typography variant='normal'>{backText}</Typography>
                    </Button>
                </Stack>
                <Stack spacing={2} direction="row" alignItems='center' justifyContent="space-between">
                    <Stack>
                        <Typography variant='heavy' fontSize='20px'>{title}</Typography>
                    </Stack>
                    { numCards !== null && 
                        <Box display='flex' alignItems='center' justifyContent='end' minWidth='45%'>
                            { showCards && 
                            <Button 
                                variant='outlined'
                                size='small'
                                onClick={showModal}
                                endIcon={<ArrowForwardIos />}
                                sx={{ color: theme.palette.primary.main }}
                            >
                                <Typography variant='normal'>Used on {numCards} cards</Typography>
                            </Button>
                            }
                        </Box>
                    }
                </Stack>
            </Stack>
        </AppBar>
    );
}

export default PackReviewHeader;